module.exports = __webpack_public_path__ + "static/media/screenshot-github.4bb02090.jpg";